import styled from 'styled-components';
import { Text } from '../Text';

const StyledContainer = styled.div`
	display: flex;
	gap: 20px;
`;

const StyledDivider = styled.div`
	width: 1px;
	height: 100%;
	background-color: #ffffff;
	opacity: 0.1;
	transition: background-color 0.3s ease;
`;

const StyledPlayerStatsContainer = styled.div<{ $transparent: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	background-color: ${({ $transparent }) =>
		$transparent ? 'rgba(255, 255, 255, 0.02)' : 'rgba(17, 19, 20, 0.98)'};
	border-radius: 10px;
	border: 1px solid
		${({ $transparent }) =>
			$transparent ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.1)'};

	${Text} {
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer, StyledDivider, StyledPlayerStatsContainer };
